import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=51a4e0f2&scoped=true&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=51a4e0f2&prod&lang=scss&scoped=true&"
import style1 from "./ContactInfo.vue?vue&type=style&index=1&id=51a4e0f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4e0f2",
  null
  
)

export default component.exports